export class OrderTypeObject {

    public static readonly CRM = new OrderTypeObject("CRM", 'crm');
    public static readonly PRODUCT = new OrderTypeObject("PRODUCT", 'product');
    public static readonly CFS = new OrderTypeObject("CFS", 'cfs');
    public static readonly RFS = new OrderTypeObject("RFS", 'rfs');
    public static readonly UNKNOWN = new OrderTypeObject("UNKNOWN", '');


    private constructor(public name: string, public urlPath: string) {

    }

    public static createWithType(type: string): OrderTypeObject {
        switch (type) {
            case this.CRM.name:
                return this.CRM;
            case this.PRODUCT.name:
                return this.PRODUCT;
            case this.CFS.name:
                return this.CFS;
            case this.RFS.name:
                return this.RFS;
            default:
                return this.UNKNOWN;
        }
    }

    public equals(type: OrderTypeObject): boolean {
        return this.name === type.name;
    }
}
